const utils = {
    isEmpty(value){
        if(value === null)
            return true;
        let length = 0;
        let typeOf = typeof value;
        if(typeOf === 'object'){
            length = Object.keys(value).length;
        }else if(typeOf === 'array'){
            length = value.length;
        }else if(typeOf === 'string'){
            length = value.length; 
        }else{
            return true;
        }
        return length > 0 ? false : true;
    },

    parseToArray(value){
        let valueType = typeof value;
        let response = [];
        switch(valueType){
            case 'string':
                response.push(value);
            break;
            case 'object':
                response = Object.values(value);
            break;
            case 'array':
                response = [];
            break;
        }
        return response;
    },

    areObjectsEqual(obj1, obj2, ignoreKeys = []){
        if (obj1 === obj2) return true;

        if (typeof obj1 !== 'object' || typeof obj2 !== 'object' || obj1 === null || obj2 === null) {
            return false;
        }
        const keys1 = Object.keys(obj1).filter(key => !ignoreKeys.includes(key));
        const keys2 = Object.keys(obj2).filter(key => !ignoreKeys.includes(key));
        if (keys1.length !== keys2.length) return false;
        for (const key of keys1) {
            if (!keys2.includes(key) || !this.areObjectsEqual(obj1[key], obj2[key], ignoreKeys)) {
            return false;
            }
        }

        return true;
    },

    copyVariable(variableData = ''){
        return JSON.parse(JSON.stringify(variableData));
    },

    isInArray(array = [], value = '', watchKey = false){
        if(watchKey){
            return array.some(item => item[watchKey] === value);
        }else{
            return array.some(item => item === value);
        }
    },

    parseDate(isoDate){
        const date = new Date(isoDate);
        const formattedDate = date.getFullYear() + '-' +
        ('0' + (date.getMonth() + 1)).slice(-2) + '-' +
        ('0' + date.getDate()).slice(-2) + ' ' +
        ('0' + date.getHours()).slice(-2) + ':' +
        ('0' + date.getMinutes()).slice(-2) + ':' +
        ('0' + date.getSeconds()).slice(-2);
        return formattedDate;
    },

    /**
     * Merges objects, always keeps the value which is not 'null' or 'undefined'
     * @param {*} obj1 
     * @param {*} obj2 
     * @returns {*}
     */
    mergeObjects(obj1, obj2) {
        return Object.keys({...obj1, ...obj2}).reduce((acc, key) => {
            acc[key] = obj1[key] !== null && obj1[key] !== undefined ? obj1[key] : obj2[key];
            return acc;
        }, {});
    },

    formatByLanguage(dateString = '', langIso = 'en', addHour = false, twentyFourHour = false, timeZone = false){
        const schema = {
            en: 'en-US',
            pt: 'pt-BR',
            es: 'es-ES'
        }
        const formatToUse = schema[langIso] != undefined ? schema[langIso] : schema.en;
        let opt = {
            day: '2-digit',
            month: '2-digit',
            year: 'numeric'
        }
        if(addHour){
            opt.hour = '2-digit';
            opt.minute = '2-digit';
            opt.second = '2-digit';
        }
        if(twentyFourHour){
            opt.hour12 = true;
        }else{
            opt.hour12 = false;
        }
        if(timeZone){
            opt.timeZone = timeZone;
        }
        const date = new Date(dateString);
        const formattedDate = date.toLocaleString(formatToUse, opt);
        return formattedDate.replace(',', ' ');
    },

    makeDateObject(dateString, lang) {
        let day, month, year;
        if(['en','pt','es'].includes(lang))
            lang = 'en';
        if (lang === 'en') {
            [month, day, year] = dateString.split('/');
        } else if (lang === 'pt' || lang === 'es') {
            [day, month, year] = dateString.split('/');
        }
        return new Date(year, month - 1, day);
    },

    jsonEncode(data = {}){
        try {
            return JSON.parse(JSON.stringify(data));
        } catch (error) {
            console.error("Erro encoding JSON:", error);
            return null;
        }
    },

    jsonDecode(jsonString){
        try {
            return JSON.parse(jsonString);
        } catch (error) {
            console.error("Erro decoding JSON:", error);
            return null;
        }
    },

    /**
     * Returns a ASCII alphabet letter accordingly to index
     * @param {integer} index 
     * @returns {String}
     */
    getAlphabetLetter(index) {
        if (index < 0 || index > 25) {
          return 'A';
        }
      
        return String.fromCharCode(65 + index);
    }
}

export default utils;